import { GET_USER_TENANT_ACCESS, RETRIEVE_USER_TENANT_ACCESS, SESSION_MODULE } from '@inpart-io/devtools-vue';
import { userTenantAccessProperties } from '@inpart-io/padme-iap';
import { type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { store } from '@/store';

import { SettingsAllAccessRoles } from './constants/platform-settings.constants';

const PlatformSettings = (): unknown => {
    return import(/* webpackPrefetch: true */ './platform-settings-page.vue');
};

export const platformSettingsRoute: RouteRecordRaw = {
    ...ROUTE_DATA.PLATFORM_SETTINGS_PAGE,
    components: { main: PlatformSettings },
    beforeEnter: async (_to, _from, next) => {
        return store
            .dispatch(`${SESSION_MODULE}/${RETRIEVE_USER_TENANT_ACCESS}`, { properties: userTenantAccessProperties.SESSION })
            .then(() => {
                const userTenantAccess = store.getters[`${SESSION_MODULE}/${GET_USER_TENANT_ACCESS}`];
                if (
                    userTenantAccess.applicationRoles.filter((role: any) => {
                        return SettingsAllAccessRoles.includes(role);
                    }).length > 0
                ) {
                    next();
                } else {
                    next({ name: ROUTE_DATA.ERROR_PAGE.name, params: { id: 403 }, replace: true });
                }
            })
            .catch((error: any) => {
                console.error(error);
                next({ name: ROUTE_DATA.ERROR_PAGE.name, params: { id: error.status }, replace: true });
            });
    },
    meta: {
        noMenu: true
    }
};
